// API Configuration
export const API_BASE_URL = 'https://your-energy.b.goit.study/api';

// Breakpoints (matches CSS)
export const BREAKPOINTS = {
  TABLET: 768,
  DESKTOP: 1440,
};

// Pagination limits per viewport
export const LIMITS = {
  CATEGORIES_MOBILE: 9,
  CATEGORIES_DESKTOP: 12,
  EXERCISES_MOBILE: 8,
  EXERCISES_TABLET: 10,
  DEFAULT: 12,
};

// LocalStorage keys
export const STORAGE_KEYS = {
  FAVORITES: 'favoriteExercises',
  QUOTE: 'quote-of-the-day',
};

// Timing
export const DEBOUNCE_MS = 300;
